module.exports = __webpack_public_path__ + "static/TiemposText-Regular-Italic-67c9b64aa0e7271a3134563a33b1cf80.woff2";